<template>
  <!-- <div :class="classObj" class="app-wrapper"> -->
  <div class="app-wrapper">
    <Zoom v-if="zoomVisible" :visible="zoomVisible"></Zoom>
    <sidebar class="sidebar-container" @tabChange="tabChange" />
    <Headbar :title="title" />
    <div class="main-container">
          <Breadcrumb></Breadcrumb>
        <app-main />
    </div>
    <!-- <Tab></Tab> -->
    <a class="float-btn" href="https://www.uniceramicsexpo.com/subscribe/index.html" target="_bland">Newsletter</a>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb.vue';
import Zoom from '@/components/zoom.vue';
// import Tab from './components/Tab.vue';



import { Headbar, Sidebar, AppMain} from './components'
// import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  data(){
    return {
      title:'',
      basePath:'',
      children:[]
    }
  },
  components: {
    Headbar,
    Sidebar,
    AppMain,
    Breadcrumb,
    Zoom
  },
  // mixins: [ResizeMixin],
  created: function(){
    // console.log(this.$store.state.zoom.visible);
    const route = this.$route
    this.basePath = route.matched[0].path;
    this.children = this.getChildren(this.basePath);
    this.title=this.getTitle;
  },
  computed: {
    routes() {
      return this.$router.options.routes
    },
    zoomVisible(){
      return this.$store.state.zoom.visible
    },
    // sidebar() {
    //   return this.$store.state.app.sidebar
    // },
    // device() {
    //   return this.$store.state.app.device
    // },
    // fixedHeader() {
    //   return this.$store.state.settings.fixedHeader
    // },
    // classObj() {
    //   return {
    //     hideSidebar: !this.sidebar.opened,
    //     openSidebar: this.sidebar.opened,
    //     withoutAnimation: this.sidebar.withoutAnimation,
    //     mobile: this.device === 'mobile'
    //   }
    // },
    getTitle(){
      return this.$route.meta.key;
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    tabChange(path){
      this.basePath=path;
      this.children = this.getChildren(path);
    },
    getChildren(path){
      const routes = this.routes
      let children = [];
      this.routes.forEach((item)=>{
        if(item.path===path){
          children = item.children;
        }
      })
      return children
    },
    getParams () {
　　　 this.title=this.getTitle;
　　}
  },
  watch: {
　　'$route': 'getParams'
　}
}
</script>


<style scoped>
@media (min-width: 991px){
.float-btn{position:fixed; background: #e70031; z-index:999; color:#fff; top:11vw; right:0; display:block; padding:14px 10px; font-size:18px; font-weight: bold;}
.sidebar-container{display:block;}
}
@media (max-width: 991px){
.float-btn{display:none;}
.sidebar-container{display:none;}
}

</style>
